export const allProducts = async (data, thunkApi) => {
  try {
    const {
      source,
      offset,
      limit,
      pricerank,
      brand,
      category,
      location,
      sort,
      pricerange,
      search,
      sub_category
    } = data;

    const { product } = thunkApi.extra.apiService;
    const response = await product.get("/", {
      params: {
        source,
        offset,
        limit,
        pricerank,
        brand,
        category,
        location,
        sort,
        pricerange,
        search,
        sub_category
      },
    });

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
